import { render, staticRenderFns } from "./LoginInput.vue?vue&type=template&id=32dafaca"
import script from "./LoginInput.vue?vue&type=script&lang=js"
export * from "./LoginInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports